/**
 * The ops shell needs the same two values as the guest shell and no more. The
 * anon key is safe in the bundle only because row level security is complete.
 */
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';
export const isConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
